/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { CircularProgress } from "@material-ui/core";
import { getRequest } from "utils/request";
import { DataTable } from "primereact/datatable";
import { i18n } from "translate/i18n";
import { Column } from "primereact/column";
import Swal from "sweetalert2";
import { putRequest } from "utils/request";
import { InputSwitch } from 'primereact/inputswitch';

import "./style.css";

export default function TabWhatsappQrCode({ companyData }) {
  const [loading, setLoading] = useState(false);
  const [globalFilter, setGlobalFilter] = useState('');
  const [ignoredUsers, setIgnoredUsers] = useState([]);


  const header = (
    <div className="data-table-header"
    >
      <i className="pi pi-search" style={{ paddingRight: 10 }}></i>
      <input
        className='input-globalfilter'
        type="search"
        onChange={(e) => setGlobalFilter(e.target.value)}
        placeholder="Buscar"
        icon="pi pi-search" />
    </div>
  )

  const getUsers = async () => {
    setLoading(true);
    const { data } = await getRequest(`/users/ignoredusers/${companyData.id}`);
    const newData = data.map((item) => {
      return { ...item, ignored: item.ignored === 1 ? "Não" : "Sim", number: item.number.split('@')[0] }
    })

    setIgnoredUsers(newData);
    setLoading(false);
  }

  const updateStatus = (id, value) => {
    Swal.fire({
      title: i18n.t('attemption'),
      text: `Você tem certeza que deseja ${value === '1' ? "não ignorar o usuário" : "ignorar o usuário"}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: i18n.t('confirmEraseCompany'),
    }).then((result) => {
      if (result.isConfirmed) {
        putRequest(`/users/ignoredUser/${id}?value=${value}`)
          .then(function (response) {
            if (response.success) {
              getUsers();
            }
          }
          )
      }
    });
  };


  const actionButtonsTemplate = (data) => {
    const disabled = data.ignored === 'Não';

    return (
      <div style={{ display: "flex", flexDirection: "row", alignItems: 'center' }}>
        <p className="ignored-text">Ignorado</p>
        <InputSwitch checked={disabled} onChange={() => updateStatus(data.id, disabled ? "2" : "1")} />
        <p className="ignored-text">Não ignorado</p>


      </div>
    )
  }

  useEffect(() => {
    getUsers();
  }, [])

  return (
    <div style={{ minHeight: '30vh' }}>
      <div className="title-helper-container">
        <h3>{companyData.nickName}</h3>
      </div>
      <h3> WHATSAPP QRCODE</h3>
      <h4 style={{ marginTop: 40 }}>Usuários</h4>
      {!loading ? (
        <DataTable
          header={header}
          globalFilter={globalFilter}
          dataKey="id"
          rowsPerPageOptions={[5, 10, 25, 50]}
          value={ignoredUsers}
          paginator
          rows={5}
          emptyMessage={i18n.t('noIgnoredUsersFinded')}
        >
          <Column field="name" header={i18n.t('name')}></Column>
          <Column field="number" header={i18n.t('number')}></Column>
          <Column sortable field="ignored" header={i18n.t('ignored')}></Column>
          <Column body={actionButtonsTemplate} header={i18n.t('action')}></Column>
        </DataTable>
      ) : (
        <div className="area-loading">
          <CircularProgress />
        </div>
      )}
    </div>
  );
}
